const API_URL = "https://www.addmecart.com";

const endPoint = {
  GETALLPRODUCT: `${API_URL}/users/products`,
  ADDTOCART: `${API_URL}/users/add-to-cart`,
  VIEWCART: `${API_URL}/users/view-cart`,
  GETCATEGORY: `${API_URL}/users/getCategory`,
  REMOVECART: `${API_URL}/users/remove-cart`,
  PLACEORDER: `${API_URL}/users/place-order`,
  CHECKOUT: `${API_URL}/users/checkout`,
  GETBRANDS: `${API_URL}/users/getBrands`,
  RECENTVIEW: `${API_URL}/users/ViewProduct`,
  GETRECENTVIEW: `${API_URL}/users/GetRecentViewd`,
  ADDWISHLIST: `${API_URL}/users/add-to-wishlist`,
  GETWISHLIST: `${API_URL}/users/get-wishlist`,
  REMOVEWISHLIST: `${API_URL}/users/remove-wishlist`,
  GETSUBCATEGORY: `${API_URL}/users/products/subcategory`,
  GETCATEGORYDATA: `${API_URL}/users/products/category`,
  RELATEDPRODUCT: `${API_URL}/users/related-product`,
  GETOFFER: `${API_URL}/users/products/flags`,
  GETOFFERNAME: `${API_URL}/users/get-flags`,
  FILTERPRODUCT: `${API_URL}/users/sortProducts/sort`,
  UPDATECART: `${API_URL}/users/update-cart`,
  LOGIN: `${API_URL}/users/login`,
  SIGNUP: `${API_URL}/users/sign-in`,
  GetProfile: `${API_URL}/users/get-user`,
  TrackOrder: `${API_URL}/users/trac-order-guest`,
  SearchProduct: `${API_URL}/users/search-product`,
  GetReview: `${API_URL}/users/get-reviews`,
  AddReviewUser: `${API_URL}users/rate-product`,
  ProductSerchById: `${API_URL}/users/products`,
  GetBannerApi: `${API_URL}/users/get-banner`,
  GetCouponApi: `${API_URL}/users/get-coupon`,
  ApplyCouponApi: `${API_URL}/users/apply-coupon`,
  SellerLoginApi: `${API_URL}/sellers/login-seller`,
  SellerRegister: `${API_URL}/sellers/register-seller`,
  SellerAccountApi: `${API_URL}/sellers/seller-account`,
  SellerGstApi: `${API_URL}/sellers/add-gst`,
  SellerPanApi: `${API_URL}/sellers/add-pan`,
  SellerAddressApi: `${API_URL}/sellers/add-address`,
  SellerBankDetails: `${API_URL}/sellers/add-bank`,
  GetSellerData: `${API_URL}/sellers/seller-fulldetails`,
  DeleteSeller: `${API_URL}/sellers/delete-account`,
  GetTopProducts: `${API_URL}/users/get-alltopsellingproduct`,
  REMOVEFREEGIFT: `${API_URL}/users/removeFreeGiftformcart`,
  ADDONLINEFREEGIFT: `${API_URL}/users/addFreeGiftForOnline`,
  GetBlogs: `${API_URL}/superAdmin/getBlogs`,
  GetBlogById: `${API_URL}/superAdmin/getBlogByTitle`,
  GetBlogCategory: `${API_URL}/superAdmin/getBlogCategory`,
  GetCategoryById: `${API_URL}/superAdmin/getBlogCategoryById`
};

export default endPoint;
